import { render } from "./CommerceLayout.vue?vue&type=template&id=3fc5015e&ts=true"
import script from "./CommerceLayout.vue?vue&type=script&lang=ts"
export * from "./CommerceLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__